// test1904
(1904 && 0);
